import { Link } from "react-router-dom";
import markPerlman from "../assets/MarkPerlman.webp";

export default function About() {
  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white border border-border rounded-2xl px-11 py-10 max-[680px]:px-6 max-[680px]:py-7">
        <h1 className="font-display text-[30px] font-semibold text-primary-dark mb-2.5 leading-tight">About the MA &amp; PA Program</h1>
        <p className="text-sm text-[#555] leading-relaxed max-w-[620px]">
          A curriculum designed to strengthen the couple relationship through a shared exploration of parenting attitudes and skills.
        </p>
      </div>

      {/* Author */}
      <div className="bg-white border border-border rounded-2xl px-10 py-9 flex gap-8 text-sm text-[#444] leading-[1.7] max-[680px]:px-6 max-[680px]:flex-col">
        <img src={markPerlman} alt="Mark Perlman" className="w-44 h-44 rounded-2xl object-cover object-top shrink-0 self-start max-[680px]:w-32 max-[680px]:h-32" />
        <div>
          <h2 className="font-display text-xl font-semibold text-primary-dark">Mark Perlman, MA</h2>
          <div className="text-[13px] text-primary font-medium italic mb-3">Author of the MA &amp; PA Program</div>
          <p className="max-w-[720px]">
            Mark has 35 years of experience working with parents, children and families in strengthening the family bond. He authored <a href="https://www.nurturingfathers.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">The Nurturing Father's Program</a>, a 13-week parenting curriculum for men that has been utilized by thousands of fathers and implemented by organizations such as Prevent Child Abuse, Head Start, Milwaukee Fatherhood Initiative, North Carolina Department of Corrections, State of Michigan. Mark also authored the <strong>MArrage &amp; PArenting Program (MA&amp;PA)</strong> that helps couples parent successfully as a team. He is the past Executive Director of the Family Counseling Center, The Child Protection Center and Fathers United Network (FUN) of Sarasota, Florida. He has served on the Florida Commission on Responsible Fatherhood, Commission on Marriage and Family Support, and currently on the Governor's Child Abuse Prevention and Permanency Council. Mark is the proud married father of 2 grown sons.
          </p>
        </div>
      </div>

      {/* Available in Spanish */}
      <div className="bg-white border border-border rounded-2xl px-10 py-9 flex flex-col gap-6 text-sm text-[#444] leading-[1.7] max-[680px]:px-6">
        <div>
          <h2 className="font-display text-xl font-semibold text-primary-dark mb-4">Available in Spanish</h2>

          <div className="grid grid-cols-2 gap-8 max-[680px]:grid-cols-1">
            <div>
              <h3 className="text-[13px] font-semibold text-primary mb-3">MA &amp; PA Program activities include:</h3>
              <ol className="flex flex-col gap-1.5 text-[13px] text-[#444] list-decimal list-inside">
                <li>Becoming a Couple/a Parent</li>
                <li>Roots of Marriage and Parenting</li>
                <li>Family Leadership</li>
                <li>Sharing Power</li>
                <li>Feelings: The Spice of Relationships</li>
                <li>Discipline and Teamwork</li>
                <li>Communication, Resolving Conflicts</li>
                <li>Family Life Schedule</li>
                <li>Family Fun</li>
              </ol>
            </div>

            <div>
              <h3 className="text-[13px] font-semibold text-primary mb-3">MA &amp; PA Program materials include:</h3>
              <ol className="flex flex-col gap-1.5 text-[13px] text-[#444] list-decimal list-inside">
                <li>2 easy-to-use Facilitator Manuals</li>
                <li>20 MA &amp; PA Journals (workbooks)</li>
                <li>Posters (educational aids)</li>
                <li>Forms (confidentiality, evaluation, Certificates of Completion)</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials */}
      <div className="text-[10px] font-medium tracking-[0.1em] uppercase text-[#999] px-1 -mb-2">MA and PA Testimonials</div>
      <div className="grid grid-cols-3 gap-3 max-[680px]:grid-cols-1">
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">The lessons that I have learned in this class are precious to me and I am blessed just to be here. Lesson(s) of this class are lesson(s) that we would be able to take with us in life and pass it on to our children.</p>
          <div className="text-[11px] text-primary font-medium">Wife and mother, Head Start Program</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">Should be offered to couples planning to be married. Every married couple should consider it.</p>
          <div className="text-[11px] text-primary font-medium">Wife and mother, Baptist Church</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">I really enjoyed this program. It has been a blessing.</p>
          <div className="text-[11px] text-primary font-medium">Wife and mother, Baptist Church</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">If you are ever in a pickle and don't know what to do, talk to MA&amp;PA counselors and take the class. It will help, that is if you want the help!!</p>
          <div className="text-[11px] text-primary font-medium">Married father of 14, 7, 5 year olds</div>
        </div>
        <div className="bg-white border border-border rounded-2xl p-6">
          <div className="font-display text-[40px] text-border-accent leading-none mb-2.5">"</div>
          <p className="text-[13px] text-[#444] leading-relaxed italic mb-3">I have really enjoyed the class. Learning different ways to handle all the different situations. This class is one of the best classes I have taken.</p>
          <div className="text-[11px] text-primary font-medium">Married mother of 7 and 5 year olds</div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-primary to-primary-dark rounded-2xl px-9 py-7 flex justify-between items-center gap-6 max-[680px]:flex-col">
        <div>
          <h3 className="font-display text-[18px] text-white mb-1.5">Ready to Implement the Program?</h3>
          <p className="text-[13px] text-white/75 leading-snug max-w-[480px]">
            Download the printable order form or contact us to learn about becoming a certified MA &amp; PA Consultant-Trainer for your community.
          </p>
        </div>
        <Link to="/order-form" className="bg-white text-primary text-[13px] font-medium px-5 py-2.5 rounded-[20px] transition-opacity hover:opacity-90 no-underline whitespace-nowrap">
          Order Now
        </Link>
      </div>
    </div>
  );
}
